import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { displayGreeting } from '../helper_functions/displayGreeting';
import { MdLogout } from 'react-icons/md';

function UserBox() {
  const auth = getAuth();

  const [userData, setUserData] = useState({
    name: auth.currentUser.displayName,
  });

  const { name } = userData;
  const navigate = useNavigate();

  const onLogOut = () => {
    auth.signOut();
    navigate('/login');
  };

  return (
    <div className="user-box">
      <p className="paragraph-s paragraph-bold">
        {displayGreeting()}, {name}!
      </p>

      <MdLogout className="icon u-margin-bottom-m" onClick={onLogOut} />
    </div>
  );
}

export default UserBox;
